import { render } from "./MessageArea.vue?vue&type=template&id=4255d1c4&scoped=true"
import script from "./MessageArea.vue?vue&type=script&lang=js"
export * from "./MessageArea.vue?vue&type=script&lang=js"

import "./MessageArea.vue?vue&type=style&index=0&id=4255d1c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4255d1c4"]])

export default __exports__